module.exports = __webpack_public_path__ + "static/media/processInactive.e9137a43.png";